import { HttpParams } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Analytics, logEvent } from "@angular/fire/analytics";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-comprehensive-redirect",
  templateUrl: "./comprehensive-redirect.component.html",
  styleUrls: ["./comprehensive-redirect.component.css"],
})
export class ComprehensiveRedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute, analytics: Analytics) {
    const params = this.route.snapshot.queryParams;
    const referrerId = params["id"];
    let httpParams = new HttpParams();
    const entries = Object.entries(params);
    let index = 0;

    while (index < entries.length) {
      const [key, value] = entries[index];

      if (key === "id") {
        httpParams = httpParams.append("referrer", value);
      } else if (key === "name") {
        httpParams = httpParams.append("utm_source", value);
      } else {
        httpParams = httpParams.append(key, value);
      }
      index++;
    }

    const url = `${environment.comprehensiveURL}?${httpParams.toString()}`;
    logEvent(analytics, "comprehensive-redirect", { referrerId });
    window.location.href = url;
  }

  ngOnInit(): void {}
}
